// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44":"54bb5762","409":"96bb2755","602":"e9490200","993":"96ffee1d"}[chunkId] + ".chunk.css";
};